<ng-template [ngIf]="config.name">
  <div class="form-group">
      <ion-label class="form-label">
          {{config.label | multiLang}}
          <ng-template [ngIf]="config.required">
            <ion-text color="danger">*</ion-text>
          </ng-template>
        </ion-label>
        
        <ion-select
        [formControlName]="config.name"
        [name]="config.name"
        [id]="config.name"
        [placeholder]= "placeholder"
        [required]="config.required ?  config.required : false"
        interface="action-sheet"

        >
        <ion-select-option *ngFor="let option of config.options" [value]="option.value">{{option.label | multiLang}}</ion-select-option>
        </ion-select>
        
      <div *ngIf="control.invalid && (control.dirty || control.touched)">
        <ion-text *ngIf="control.hasError('required')" color="danger" class="m-b-5">
          <span class="f-12">{{config.name}} is required</span>
        </ion-text>
      </div>
  </div>
</ng-template>